import { Component, Input, OnInit } from '@angular/core';
import { timer } from 'rxjs';
import * as moment from 'pkp-moment-timezone-all-years';

@Component({
    selector: 'timer',
    template:
        '<span [hidden]="days <= 0">{{days}}d</span> {{hours | number: "2.0"}}:{{minutes | number: "2.0"}}:{{seconds | number: "2.0"}}'
})
export class TimerComponent implements OnInit {
    private timerSource = timer(0, 1000);

    public days: number;
    public hours: number;
    public minutes: number;
    public seconds: number;

    private _endTime;

    @Input()
    public set endTime(date: Date | string) {
        this._endTime = moment(date);
    }

    ngOnInit(): void {
        this.timerSource.subscribe(() => {
            if (this._endTime) {
                let duration = moment.duration(this._endTime.diff(moment()));
                this.days = Math.max(0, Math.floor(duration.asDays()));
                this.hours = Math.max(0, duration.hours());
                this.minutes = Math.max(0, duration.minutes());
                this.seconds = Math.max(0, duration.seconds());
            }
        });
    }
}
